import { render, staticRenderFns } from "./light.vue?vue&type=template&id=094a7c6a&scoped=true"
import script from "./light.vue?vue&type=script&lang=js"
export * from "./light.vue?vue&type=script&lang=js"
import style0 from "./light.vue?vue&type=style&index=0&id=094a7c6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094a7c6a",
  null
  
)

export default component.exports